/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_PROJECTSETUPDATA, PROJECTSETUPDATA_RECEIVED, REQUEST_UPDATE_TASK_STATUS } = constants.Projectsetdata;

export default {
    REQUEST_PROJECTSETUPDATA,
    PROJECTSETUPDATA_RECEIVED,
    REQUEST_UPDATE_TASK_STATUS,

  requestProjectset: payload => ({
    type: REQUEST_PROJECTSETUPDATA,
    payload
  }),
  projectsetReceived: () => ({
    type: PROJECTSETUPDATA_RECEIVED
  }),
  requestUpdateTaskStatus: payload =>({
    type: REQUEST_UPDATE_TASK_STATUS,
    payload
  })
};
